import request from '@/utils/axios.js'

// 获取验证码
export function getSendCode (data) {
  return request({
    url: '/usercenter/userAPI/user/captcha/send',
    method: 'post',
    data: data
  })
}

// 验证码登录接口
export function getRegister (data) {
  return request({
    url: '/auth/login/sms',
    method: 'post',
    data: data
  })
}

// 领取优惠券
export function getCoupon () {
  return request({
    url: '/usercenter/mobileAPI/user/activity/kehao',
    method: 'get',
    data: ''
  })
}
